import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchPublications } from "../../../../actions/filters-actions";
import { FILTER_NAMES } from "../../../../constants/app-constant";
import useDebounce from "../../../../custom_hooks/debounce";
import { CloseIcon, TagClose } from "../../../Icons/icons.component";
import { Input } from "../../../Shared/FormElements/Input";
import { FilterItem } from "../FilterItem";

const {
  REMOVE_PUBLICATION_TEXT,
  TYPED_PUBLICATION_TEXT,
  PUBLICATION_IDS,
} = FILTER_NAMES;

export default function PublicationFilter({
  filters,
  handleFilterSelect,
  selectedFilter,
  setSelectedFilter,
  filterOption,
  client_id,
  disabled,
  selectedVertical,
}) {
  const dispatch = useDispatch();
  const { typedPublication, edition, vertical, publication_type } = filters;
  const typedSearchKey = useDebounce(typedPublication, 700);
  const [checkedId, setCheckedId] = useState([]);
  useEffect(() => {
    dispatch(
      fetchPublications(
        client_id,
        edition,
        typedPublication && typedPublication.join(","),
        selectedVertical,
        publication_type
      )
    );
  }, [typedSearchKey]);

  const publicationDataList =
    useSelector((state) => state.filterReducer.publicationData) || [];

  useEffect(() => {
    setClass();
  }, [filters]);

  const setClass = () => {
    if (filters && filters.publication) {
      setCheckedId(
        filters.publication.map(i => i.id)
      );
    }
  };

  const typedPublicationLength =
    filters.typedPublication && filters.typedPublication.length;

  return (
    <div id="pubfilterContainer" className="form-group publicFilterWrap">
      <div className="filterDiv">
        <FilterItem
          filters={filters}
          setSelectedFilter={setSelectedFilter}
          selectedFilter={selectedFilter}
          handleFilterSelect={handleFilterSelect}
          filterOption={filterOption}
          disabled={disabled}
        />
      </div>
      <div className="filteInputText">
        <label>Publication</label>
        <div className="tagTileWrap">
          {filters.publication &&
            filters.publication.map((e) => {
              if (!e) {
                return null;
              }
              return (
                <span
                  key={e.id}
                  onClick={() =>
                    handleFilterSelect(REMOVE_PUBLICATION_TEXT, e)
                  }
                  className="tagTile"
                >
                  {e.text}
                  <span className="tagTileRemove">
                    <TagClose />
                  </span>
                </span>
              );
            })}
          <Input
            id="publication-filter"
            type="text"
            onChange={(value) => {
              handleFilterSelect(TYPED_PUBLICATION_TEXT, value);
            }}
            value={filters.typedPublication}
            placeholder="Type here.."
            disabled={!filters.publication_type}
          ></Input>
          <ul
            id="data"
            className={`autoSuggest ${typedPublicationLength ? "show" : "hide"}`}
          >
            {!publicationDataList.length ? (
              <li>Searching...</li>
            ) : (
                publicationDataList.map(({ id, text }) => (
                  <li
                    onClick={(e) => {
                      handleFilterSelect(PUBLICATION_IDS, { text, id });
                    }}
                    key={id}
                    value={text}
                    className={
                      checkedId.indexOf(id.toString()) != -1
                        ? "filterOption bg-gray"
                        : "filterOption"
                    }
                  >
                    {text}
                  </li>
                ))
              )}
          </ul>
        </div>
      </div>
    </div>
  );
}
